<template>
	<div class="Factory">
		<common-body aside="6">
			<div slot="commonMain" class="offer_box">
				<div class="lq-toolbar offer_header">
					<el-input
						v-model="search"
						class="lq-search"
						clearable
						prefix-icon="el-icon-search"
						placeholder="搜索单号 / 客户 / 物流"
						@keyup.enter.native="searchList" />
					<el-date-picker
						class="lq-date header_date"
						value-format="timestamp"
						:editable="editable"
						unlink-panels
						size="small"
						@change="getDate"
						v-model="dateTime"
						type="daterange"
						range-separator="-"
						start-placeholder="开始日期"
						end-placeholder="结束日期" />
					<div class="lq-toolbar-actions">
						<el-button type="primary" size="small" @click="searchList">查询</el-button>
						<el-button size="small" @click="delSearch">清空</el-button>
					</div>
					<div class="lq-toolbar-right">
						<el-button
							v-if="ruleList.factory_list"
							type="warning"
							size="small"
							plain
							icon="el-icon-scissors"
							@click="openMergeCutting">
							多单切料
						</el-button>
					</div>
				</div>
				<div v-if="categoryName" class="lq-category-hint">当前分类：{{ categoryName }}</div>
				<el-table ref="listTable" stripe class="lq-table lq-table--clickable" :data="list" style="width: 100%" cell-class-name="good_text" header-cell-class-name="good_header" @row-dblclick="handleRowDblClick">
					<el-table-column align="center" width="64" label="序号" class-name="lq-index-col" header-align="center">
						<template slot-scope="scope">
							<div>{{scope.$index+1}}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="108" prop="order_number" label="单号" show-overflow-tooltip>
						<template slot-scope="scope">
							<span
								class="lq-order-no"
								:class="{ 'lq-order-no--after-sales': isAfterSalesRow(scope.row) }">
								{{ scope.row.order_number }}
							</span>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="108" prop="customer_name" label="定货方" show-overflow-tooltip>
					</el-table-column>
					<el-table-column align="center" min-width="80" prop="delivery_text" label="运输方式" show-overflow-tooltip>
					</el-table-column>
					<el-table-column align="center" min-width="96" prop="createTime" label="下单日期">
					</el-table-column>
					<el-table-column align="center" min-width="120" prop="order_sn" label="物流信息" show-overflow-tooltip>
						<template slot-scope="scope">
							<div>{{ isShippedRow(scope.row) ? (scope.row.order_sn || '') : '' }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="80" prop="deliver" label="发货人" show-overflow-tooltip>
						<template slot-scope="scope">
							<div>{{ isShippedRow(scope.row) ? (scope.row.deliver || '') : '' }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="96" prop="sendTime" label="发货日期">
						<template slot-scope="scope">
							<div>{{ isShippedRow(scope.row) ? (scope.row.sendTime || '') : '' }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" width="48" label="状态" class-name="lq-ship-status-col" header-align="center">
						<template slot="header">
							<el-tooltip content="发货状态" placement="top" :open-delay="300">
								<span class="lq-ship-status-head">状态</span>
							</el-tooltip>
						</template>
						<template slot-scope="scope">
							<el-tooltip :content="scope.row.status_text" placement="top" :open-delay="300">
								<div class="lq-ship-status-cell">
									<i
										:class="shipStatusIconClass(scope.row.status)"
										aria-hidden="true"></i>
								</div>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column align="left" min-width="160" label="备注" class-name="lq-remarks-col" header-align="center">
						<template slot-scope="scope">
							<lq-remarks-cell :text="remarksContent(scope.row)" />
						</template>
					</el-table-column>
					<el-table-column align="center" width="112" label="操作" fixed="right" class-name="lq-action-col" header-align="center">
						<template slot-scope="scope">
							<div v-if="!ruleList.factory_list"></div>
							<div v-else class="lq-row-actions">
								<el-tooltip content="订单详情" placement="top">
									<el-button type="text" icon="el-icon-view" class="lq-row-action-btn" @click="showDetail(scope.$index)" />
								</el-tooltip>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination class="good_page" :hide-on-single-page="pageSingle" @current-change="changePage" :page-size="limit"
				 prev-text="上一页" next-text="下一页" background layout="prev, pager, next" :total="listTotal">
				</el-pagination>
			</div>
		</common-body>

		<el-dialog
			title="多单切料"
			:visible.sync="mergeVisible"
			width="96%"
			top="3vh"
			custom-class="merge-cutting-dialog"
			append-to-body
			@closed="onMergeClosed">
			<div v-loading="mergeLoading" class="merge-cutting">
				<div class="merge-cutting__hint">
					仅包含当前角色组生产查询全部可见页码内的订单（未发货且可切，受列表可见上限约束）。可展开「推荐」查看同 SKU 跨单建议；勾选订单后合并下料。从切料页返回将恢复本次勾选。
				</div>
				<div class="merge-cutting__body" :class="{ 'is-reco-collapsed': !recoExpanded }">
					<div v-if="recoExpanded" class="merge-cutting__panel merge-cutting__panel--reco">
						<div class="merge-cutting__panel-title">
							<span class="merge-cutting__panel-title-main">
								推荐
								<span class="merge-cutting__count">{{ mergeRecommendations.length }}</span>
							</span>
							<el-button
								type="text"
								class="merge-cutting__fold-btn"
								@click="recoExpanded = false">
								折叠
								<i class="el-icon-arrow-left" />
							</el-button>
						</div>
						<div class="merge-cutting__panel-body">
							<el-table
								v-if="recoTableRows.length"
								:data="recoTableRows"
								border
								stripe
								size="small"
								:height="mergeTableHeight"
								row-key="key"
								class="merge-cutting__table merge-cutting__table--reco">
								<el-table-column prop="label" label="SKU" min-width="200" class-name="merge-col-sku">
									<template slot-scope="scope">
										<div class="merge-sku-text">{{ scope.row.label }}</div>
									</template>
								</el-table-column>
								<el-table-column prop="order_count" label="单数" width="64" align="center" />
								<el-table-column prop="piece_count" label="支数" width="64" align="center" />
								<el-table-column label="涉及订单" min-width="220" class-name="merge-col-orders">
									<template slot-scope="scope">
										<div
											v-for="(ord, oi) in scope.row.order_rows"
											:key="ord.id + '-' + oi"
											class="merge-reco-order-line">
											<span class="merge-reco-order-no">{{ ord.order_number }}</span>
											<span class="merge-reco-order-cust">{{ ord.customer_name || '—' }}</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column label="操作" width="118" align="center" fixed="right">
									<template slot-scope="scope">
										<el-button
											:type="isRecoSelected(scope.row) ? 'info' : 'primary'"
											plain
											size="mini"
											@click="toggleRecommendation(scope.row)">
											{{ isRecoSelected(scope.row) ? '取消勾选' : '勾选' }}
										</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div v-else class="merge-cutting__empty">
								暂无跨单同 SKU 推荐（需至少两单含相同规格）
							</div>
						</div>
					</div>
					<div class="merge-cutting__panel merge-cutting__panel--orders">
						<div class="merge-cutting__panel-title">
							<span class="merge-cutting__panel-title-main">
								可选订单
								<span class="merge-cutting__count">已选 {{ selectedMergeIds.length }}</span>
							</span>
							<el-button
								v-if="!recoExpanded"
								type="text"
								class="merge-cutting__fold-btn"
								@click="recoExpanded = true">
								展开推荐
								<i class="el-icon-arrow-right" />
							</el-button>
							<el-button
								v-else
								type="text"
								class="merge-cutting__fold-btn"
								@click="recoExpanded = false">
								折叠推荐
								<i class="el-icon-arrow-left" />
							</el-button>
						</div>
						<div class="merge-cutting__panel-body">
							<el-table
								ref="mergeTable"
								:data="mergeOrders"
								border
								stripe
								size="small"
								:height="mergeTableHeight"
								row-key="id"
								class="merge-cutting__table"
								@selection-change="onMergeSelectionChange">
								<el-table-column type="selection" width="48" align="center" :reserve-selection="true" />
								<el-table-column prop="order_number" label="单号" min-width="150" class-name="merge-col-orderno" show-overflow-tooltip />
								<el-table-column prop="customer_name" label="定货方" min-width="140" show-overflow-tooltip />
								<el-table-column label="下单日期" min-width="150" align="center" class-name="merge-col-date">
									<template slot-scope="scope">
										<span class="merge-date-text">{{ formatOrderTime(scope.row.create_time) }}</span>
									</template>
								</el-table-column>
								<el-table-column label="支数" width="72" align="center" prop="piece_count" />
								<el-table-column label="SKU" min-width="320" class-name="merge-col-sku">
									<template slot-scope="scope">
										<div class="merge-sku-text">{{ formatOrderSkus(scope.row) }}</div>
									</template>
								</el-table-column>
							</el-table>
							<div v-if="!mergeLoading && !mergeOrders.length" class="merge-cutting__empty merge-cutting__empty--overlay">
								暂无含可切长度的未发货订单
							</div>
						</div>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="mergeVisible = false">取消</el-button>
				<el-button type="primary" :disabled="!selectedMergeIds.length" @click="confirmMergeCutting">
					开始切料优化
				</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getT
	} from "../assets/js/public.js"
	import {
		fetchQuotationCategory
	} from "../utils/quotation-category.js"

	const MERGE_RESTORE_KEY = 'factory_merge_cutting_restore'

	export default {
		name: 'Factory',
		data() {
			return {
				categoryId: 0,
				categoryName: '',
				categoryWarned: !1,
				skipNextActivated: !0,
				ruleList: JSON.parse(localStorage.getItem('ruleList')),
				editable: !1,
				search: '',
				page: 1,
				pageSingle: !1,
				limit: 10,
				listTotal: 0,
				list: [],
				dateTime: '',
				stime: '',
				etime: '',
				mergeVisible: !1,
				mergeLoading: !1,
				mergeOrders: [],
				mergeRecommendations: [],
				selectedMergeIds: [],
				mergeTableHeight: 520,
				mergeNavigating: !1,
				mergeRestoreIds: null,
				recoExpanded: !1,
			}
		},
		created() {
			this.reload();
		},
		activated() {
			if (this.skipNextActivated) {
				this.skipNextActivated = !1
				return
			}
			this.reload();
		},
		beforeRouteLeave(to,from,next) {
			from.meta.keepAlive = !1
			next()
		},
		computed: {
			recoTableRows() {
				const orderMap = new Map(
					(this.mergeOrders || []).map((o) => [Number(o.id), o]),
				)
				return (this.mergeRecommendations || []).map((item) => {
					const ids = item.order_ids || []
					const nums = item.order_numbers || []
					const order_rows = ids.map((id, idx) => {
						const o = orderMap.get(Number(id))
						return {
							id: Number(id),
							order_number: (o && o.order_number) || nums[idx] || String(id),
							customer_name: (o && o.customer_name) || '',
						}
					})
					return {
						...item,
						order_count: ids.length,
						order_rows,
					}
				})
			},
		},
		methods: {
			isAfterSalesRow(row) {
				return !!(row && String(row.pay_status) === '3')
			},
			remarksContent(row) {
				const text = row && row.remarks != null ? String(row.remarks).trim() : '';
				return text;
			},
			shipStatusIconClass(status) {
				const shipped = String(status) === '2';
				return [
					'lq-ship-status-icon',
					shipped ? 'el-icon-circle-check good_pay2' : 'el-icon-time good_pay1'
				];
			},
			isShippedRow(row) {
				return row && String(row.status) === '2';
			},
			formatOrderTime(ts) {
				const n = Number(ts)
				if (!(n > 0)) return '—'
				const text = getT(n * 1000)
				// 避免转行：去掉秒，保留到分钟
				return String(text).replace(/:\d{2}$/, '')
			},
			formatOrderSkus(row) {
				return ((row && row.skus) || []).map((s) => s.label).filter(Boolean).join('；')
			},
			readMergeRestoreState() {
				try {
					const raw = sessionStorage.getItem(MERGE_RESTORE_KEY)
					if (!raw) return null
					const data = JSON.parse(raw)
					if (!data || !data.reopen) return null
					const ids = Array.isArray(data.ids)
						? data.ids.map((n) => Number(n)).filter((n) => n > 0)
						: []
					const page = Number(data.page) > 0 ? Number(data.page) : 1
					return { reopen: true, ids, page }
				} catch (e) {
					return null
				}
			},
			saveMergeRestoreState(ids) {
				try {
					sessionStorage.setItem(MERGE_RESTORE_KEY, JSON.stringify({
						reopen: true,
						ids: (ids || []).map((n) => Number(n)).filter((n) => n > 0),
						page: this.page,
					}))
				} catch (e) { /* ignore */ }
			},
			clearMergeRestoreState() {
				try {
					sessionStorage.removeItem(MERGE_RESTORE_KEY)
				} catch (e) { /* ignore */ }
			},
			tryRestoreMergeDialog() {
				const state = this.readMergeRestoreState()
				if (!state || !this.categoryId) return
				if (state.page > 0 && state.page !== this.page) {
					this.page = state.page
					this.getList()
				}
				this.mergeRestoreIds = state.ids
				this.mergeVisible = true
				this.loadMergeCandidates(state.ids)
			},
			reload() {
				let that = this
				fetchQuotationCategory(that.$fetch.bind(that)).then(function(info) {
					that.categoryId = info.categoryId
					that.categoryName = info.categoryName || ''
					that.page = 1
					that.getList()
					that.tryRestoreMergeDialog()
				})
			},
			getList(e) {
				let that = this
				if (!that.categoryId) {
					that.list = []
					that.listTotal = 0
					that.layoutTable()
					if (!that.categoryWarned) {
						that.categoryWarned = !0
						that.$message({
							message: '请先在产品列表选择产品分类',
							center: !0,
							type: 'warning',
							duration: 1500
						})
					}
					return
				}
				that.$fetch('addons/hlm/api.Order/getFactoryList', {
					page: that.page,
					limit: that.limit,
					search: that.search,
					stime: that.stime,
					etime: that.etime,
					type: that.categoryId
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						let list = res.data.list
						list.forEach((item, index) => {
							const orderTs = Number(item.offertime) > 0 ? Number(item.offertime) : Number(item.createtime)
							item.createTime = orderTs > 0 ? getT(orderTs * 1000) : ''
							let sendTs = 0
							if (String(item.status) === '2') {
								sendTs = Number(item.sendtime) > 0
									? Number(item.sendtime)
									: (Number(item.updatetime) > 0 ? Number(item.updatetime) : 0)
							}
							item.sendTime = sendTs > 0 ? getT(sendTs * 1000) : ''
						})
						that.list = list, that.listTotal = res.data.total
						that.layoutTable()
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			layoutTable() {
				this.$nextTick(() => {
					const table = this.$refs.listTable
					if (table && table.doLayout) table.doLayout()
				})
			},
			getDate(e){
				let that = this
				that.stime = e[0]/1000,that.etime = e[1]/1000				
				if(e[1]/1000<e[0]/1000) that.stime = e[1]/1000,that.etime = e[0]/1000
			},
			changePage(e) {
				let that = this
				that.page = e, that.getList()
			},
			searchList(e) {
				let that = this
				that.getList()
			},
			delSearch(){
				let that = this
				that.search = "",that.dateTime = "",that.etime = "",that.stime = ""
			},
			showDetail(e) {
				let that = this,id = that.list[e].id
				that.$router.push(`/factoryDetail?id=${id}`)
			},
			handleRowDblClick(row) {
				if (!this.ruleList.factory_list) return
				const index = this.list.findIndex((item) => item.id === row.id)
				if (index >= 0) this.showDetail(index)
			},
			openMergeCutting() {
				if (!this.categoryId) {
					this.$message.warning('请先在产品列表选择产品分类')
					return
				}
				const that = this
				that.$confirm(
					[
						'<div class="merge-cut-warn">',
						'<div class="merge-cut-warn__banner">⚠ 重要提醒：未改发货状态 = 可能重复生产</div>',
						'<p class="merge-cut-warn__lead">进入多单切料前，请先核对<strong>当前订单列表</strong>中已实际发货的订单：</p>',
						'<ol class="merge-cut-warn__list">',
						'<li>已填写<strong>物流信息</strong>（快递单号等）</li>',
						'<li>订单状态已改为<strong>「已发货」</strong></li>',
						'</ol>',
						'<div class="merge-cut-warn__risk">若发货后未改状态，系统仍会把它当作未发货单纳入切料，造成<strong>重复下料、重复生产</strong>的损失。</div>',
						'<p class="merge-cut-warn__ask">请确认以上事项均已处理后再继续。</p>',
						'</div>',
					].join(''),
					'多单切料 — 发货状态确认',
					{
						confirmButtonText: '已核对发货状态，继续',
						cancelButtonText: '返回检查',
						type: 'error',
						customClass: 'merge-cutting-warn-box',
						dangerouslyUseHTMLString: true,
						distinguishCancelAndClose: true,
						closeOnClickModal: false,
						closeOnPressEscape: false,
					},
				).then(function() {
					that.doOpenMergeCutting()
				}).catch(function() {})
			},
			doOpenMergeCutting() {
				const state = this.readMergeRestoreState()
				const restoreIds = state && state.ids && state.ids.length ? state.ids : null
				this.mergeRestoreIds = restoreIds
				this.mergeVisible = true
				this.loadMergeCandidates(restoreIds)
			},
			loadMergeCandidates(restoreIds) {
				const that = this
				const idsToRestore = Array.isArray(restoreIds) ? restoreIds : that.mergeRestoreIds
				that.mergeLoading = true
				that.mergeOrders = []
				that.mergeRecommendations = []
				if (!idsToRestore || !idsToRestore.length) {
					that.selectedMergeIds = []
				}
				that.$fetch('addons/hlm/api.Order/getMergeCuttingCandidates', {
					type: that.categoryId,
					search: that.search,
					stime: that.stime,
					etime: that.etime,
				}).then(function(res) {
					if (res.code == 1) {
						that.mergeOrders = res.data.orders || []
						that.mergeRecommendations = res.data.recommendations || []
						that.$nextTick(function() {
							that.applyMergeSelection(idsToRestore || [])
						})
					}
				}).catch(function(error) {
					console.log(error)
				}).finally(function() {
					that.mergeLoading = false
					that.mergeRestoreIds = null
				})
			},
			applyMergeSelection(ids) {
				const table = this.$refs.mergeTable
				if (!table) return
				if (table.clearSelection) table.clearSelection()
				const idSet = new Set((ids || []).map((n) => Number(n)).filter((n) => n > 0))
				if (!idSet.size) {
					this.selectedMergeIds = []
					return
				}
				this.mergeOrders.forEach((row) => {
					if (idSet.has(Number(row.id))) {
						table.toggleRowSelection(row, true)
					}
				})
			},
			onMergeSelectionChange(rows) {
				this.selectedMergeIds = (rows || []).map((r) => Number(r.id)).filter((n) => n > 0)
			},
			isRecoSelected(item) {
				const ids = (item && item.order_ids) || []
				if (!ids.length) return false
				const selected = new Set((this.selectedMergeIds || []).map((n) => Number(n)))
				return ids.every((id) => selected.has(Number(id)))
			},
			toggleRecommendation(item) {
				const ids = (item && item.order_ids) || []
				if (!ids.length) return
				const table = this.$refs.mergeTable
				if (!table) return
				const idSet = new Set(ids.map((n) => Number(n)))
				const selected = this.isRecoSelected(item)
				this.mergeOrders.forEach((row) => {
					if (idSet.has(Number(row.id))) {
						table.toggleRowSelection(row, !selected)
					}
				})
				this.$message.success(selected ? '已取消勾选' : '已勾选推荐订单')
			},
			confirmMergeCutting() {
				if (!this.selectedMergeIds.length) {
					this.$message.warning('请先勾选订单')
					return
				}
				const ids = this.selectedMergeIds.slice()
				this.saveMergeRestoreState(ids)
				this.mergeNavigating = true
				this.mergeVisible = false
				this.$router.push(`/cuttingPrint?ids=${ids.join(',')}`)
			},
			onMergeClosed() {
				if (this.mergeNavigating) {
					this.mergeNavigating = false
					return
				}
				// 主动关闭弹窗：清除返回恢复状态
				this.clearMergeRestoreState()
				this.selectedMergeIds = []
				this.mergeOrders = []
				this.mergeRecommendations = []
				this.mergeRestoreIds = null
				this.recoExpanded = false
			},
			delList(e){
				let that = this,
					id = that.list[e].id
				that.$fetch('addons/hlm/api.order/del', {
					id: id
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.detailStatus = !1, that.$message({
							message: '删除成功',
							type: 'success',
							duration: 1500,
							center: !0,
							onClose() {
				
							}
						}), that.getList()
					}
				}).catch(function(error) {
					console.log(error)
				})
			}
		}
	};
</script>

<style src='../assets/css/factory.css'>
	/* px2rem能正常转换 */
</style>
